// Действие внутри пина карты. Кнопка с этим атрибутом — контракт между вёрсткой пина
// (BalloonManager/markups) и обработчиком кликов по стрелкам: обработчик ищет ближайший
// элемент с атрибутом и по его значению понимает, что делать.
export const PIN_ACTION_ATTR = 'data-pin-action';

export enum EPinAction {
  PrevOffer = 'prev-offer',
  NextOffer = 'next-offer',
}
